import React from 'react';


const DivCenter = ({ children, className = '', style = {} }) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default DivCenter;
